// extracted by mini-css-extract-plugin
export default {"utility-icons":"UtilityIcons_utility-icons__+NnCm","utility-icons__item":"UtilityIcons_utility-icons__item__3aeCe"};